const HotpleLogo = ({ className }) => {
  return (
    <div className="relative">
      <img
        alt="logo"
        src="/images/main-logo.png"
        width={68}
        height={10}
        loading="eager"
        decoding="sync"
        fetchPriority="high"
        className={`${className} dark:invert mb-1`}
      />
      <span className="absolute top-0 right-0 translate-x-6 -translate-y-3 text-[11px] font-semibold playwrite-dk-loopet">
        Beta
      </span>
    </div>
  );
};

export default HotpleLogo;
